export default __webpack_public_path__ + "static/media/medium-small.7a5d6e96.svg";